import CartboxPrices from './CartboxPrices'
import cartboxPricesContainer from './cartboxPricesContainer'

export default cartboxPricesContainer(CartboxPrices)
